import "./assets/css/ck-content-styles.css";
import "./assets/css/tailwind.css";
import "./assets/css/main.css";

import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { resolveLocaleBeforeFirstPaint } from "./i18n/detectLocale";
import { LocaleProvider } from "./i18n/LocaleContext";
import reportWebVitals from "./reportWebVitals";

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  void resolveLocaleBeforeFirstPaint().then((initialLocale) => {
    root.render(
      <React.StrictMode>
        <LocaleProvider initialLocale={initialLocale}>
          <App />
        </LocaleProvider>
      </React.StrictMode>,
    );
  });
}

reportWebVitals();
